import React, { useState, useCallback, useRef } from "react";
import "./AllUsers.css";
import { Container, Row, Col, Form } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllUsers,
  setProgressMessage,
  setWarningMessage,
  setCompletedMessage,
} from "../../Actions/adminActions";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import apiCall from "./../../API/API";
import moment from "moment";
import debounce from "lodash.debounce";
// import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  API_BASE_PATH_USER_LOGIN,
  SOCKET_SERVER_URL_WSS,
} from "./../../API/API";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const SOCKET_SERVER_URL = SOCKET_SERVER_URL_WSS;

const AllUsers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.admin);
  const [filter, setFilter] = useState("none");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const [showModal, setShowModal] = useState(false);
  const [showTreeModal, setShowTreeModal] = useState(false);
  const [showSocialProfilesModal, setShowSocialProfilesModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserSocialProfiles, setSelectedUserSocialProfiles] =
    useState(null);
  const [selectedUid, setSelectedUid] = useState(null);
  const [blockStatus, setBlockStatus] = useState(0);
  const [treeStatus, setTreeStatus] = useState(0);
  const [activityData, setActivityData] = useState([]);
  const reconnectTimeoutRef = useRef(null);
  const wsRef = useRef(null);
  const progressMessage = useSelector((state) => state.admin.progressMessage);
  const warningMessage = useSelector((state) => state.admin.warningMessage);
  const completedMessage = useSelector((state) => state.admin.completedMessage);
  const [uid, setUid] = useState();
  const [userName, setUserName] = useState();
  const [sponsorUsername, setSponsorUsername] = useState();
  const [newSponsor, setNewSponsor] = useState();
  const [sponsorShow, setSponsorShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [existUserName, setExistUserName] = useState();
  const [search, setsearch] = useState({
    name: "",
    username: "",
    uid: "",
    startDateJoining: "",
    endDateJoining: "",
    /*fromDate:'',
    toDate:'',*/
    status: "",
    identify_user: "",
  });
  const [dateFilter, setDateFilter] = useState("default");

  const fetchUsers = useCallback(
    debounce((params) => {
      dispatch(fetchAllUsers(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setsearch((prev) => {
      const updatedSearch = { ...prev, [name]: value };
      Object.keys(updatedSearch).forEach((key) => {
        if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
          delete updatedSearch[key];
        }
      });
      return updatedSearch;
    });

    fetchUsers({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    });
  };

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let startDateJoining = "";
    let endDateJoining = "";
    switch (value) {
      case "today":
        startDateJoining = today.startOf("day").format("YYYY-MM-DD");
        endDateJoining = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        startDateJoining = today
          .subtract(1, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        endDateJoining = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        startDateJoining = today.startOf("week").format("YYYY-MM-DD");
        endDateJoining = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        startDateJoining = today.startOf("month").format("YYYY-MM-DD");
        endDateJoining = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        startDateJoining = "";
        endDateJoining = "";
        break;
    }
    setsearch((prev) => ({
      ...prev,
      startDateJoining,
      endDateJoining,
    }));
  };
  const AddFilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    dispatch(fetchAllUsers(queryParams));
  };

  const loginUser = async (username) => {
    // console.log("userId", username);
    try {
      const { data, error } = await apiCall(
        "POST",
        "/login-user",
        { username },
        true
      );
      if (data) {
        // window.open(
        //   `http://192.168.1.99:3002/dashboard/?token=${data.token}`,
        //   "_blank"
        // );
        window.open(
          `${API_BASE_PATH_USER_LOGIN}/?token=${data.token}`,
          "_blank"
        );
      }
    } catch (error) {
      console.error("Error logging in user:", error);
    }
  };

  const resetFilter = () => {
    const queryParams = {
      page: "1",
      limit: 20,
    };
    dispatch(fetchAllUsers(queryParams));
    setsearch({
      name: "",
      username: "",
      startDateJoining: "",
      endDateJoining: "",
      uid: "",
      status: "",
      identify_user: "",
    });
    setLimitFilter(20);
    setDateFilter("default");
    setCurrentPage(1);
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search)?.filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    fetchUsers(queryParams);
  }, [currentPage, limitFilter, search, fetchUsers]);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (username, status) => {
    setSelectedUser(username);
    setBlockStatus(status);
    setShowModal(true);
  };

  const BlockUsers = async (username, block_Status) => {
    try {
      const { data, error } = await apiCall("POST", "/user_block_unblock", {
        username,
        block_Status,
      });

      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(
          data.message ||
            (blockStatus === 1 ? "User is blocked!" : "User is unblocked!")
        );
        const queryParams = {
          page: currentPage,
          limit: limitFilter,
          ...Object.fromEntries(
            Object.entries(search).filter(
              ([_, value]) => value !== "" && value !== 0
            )
          ),
        };

        try {
          dispatch(fetchAllUsers(queryParams));
        } catch (error) {
          console.log("2222222222222222222", error);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const BlockUserTree = async (uid, action) => {
    const disenable = action == 0 ? "disable" : "enable";
    console.log("disenable", disenable);
    try {
      const { data, error } = await apiCall("POST", "/block_tree_widthrawal", {
        uid: uid,
        action: disenable,
      });

      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(
          data.message ||
            (blockStatus === 1 ? "User is blocked!" : "User is unblocked!")
        );
        const queryParams = {
          page: currentPage,
          limit: limitFilter,
          ...Object.fromEntries(
            Object.entries(search).filter(
              ([_, value]) => value !== "" && value !== 0
            )
          ),
        };

        try {
          dispatch(fetchAllUsers(queryParams));
        } catch (error) {
          console.log("2222222222222222222", error);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    setTotalRecords(userData?.totalRecords);
    if (userData?.totalPages) {
      setTotalPages(userData.totalPages);
    }
  }, [userData]);

  const [totalRecord, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);

  const handleExportExcel = async () => {
    try {
      // const queryParams = {
      //   source: "generate_fund",
      //   limit: totalRecord
      // }
      const { data } = await apiCall(
        "GET",
        `/get-all-users?limit=${totalRecord}`,
        null,
        false
      );

      setExportData(data?.data);

      // console.log("export excel response", data?.data);
      // toast.success("Excel file has been downloaded!");
    } catch (error) {
      // toast.error("Failed to export data");
    }
  };
  useEffect(() => {
    handleExportExcel();
  }, []);

  const fetchActivities = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get-all-activity");
      if (data) {
        console.log("2222222222222", data?.activities);
        const activities = data?.activities;
        console.log(activities, "activities");
        setActivityData(activities);
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  const getDisabledActivityNames = (disabledActivities, allActivities) => {
    return disabledActivities?.map((actId) => {
      const activity = allActivities.find((act) => act.act_id === actId);
      return activity ? activity?.view : "Unknown Activity";
    });
  };
  const [showEnableModal, setShowEnableModal] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [activityLength, setActivityLength] = useState();
  const [selectActivityId, setSelectActivityId] = useState([]);
  const [showEnableTreeModal, setShowEnableTreeModal] = useState(false);
  const [showDisableTreeModal, setShowDisableTreeModal] = useState(false);

  const handleButtonClick = (activity, activityAction) => {
    setSelectedActivity(activity);
    setActivityLength(activity?.disabled_activities.length);
    console.log(activity?.disabled_activities.length, "activity");
    if (activityAction === "enable") {
      setShowEnableModal(true);
    } else {
      setShowDisableModal(true);
    }
  };

  const handleDisableModalClose = (activityAction) => {
    if (activityAction === "enable") {
      setShowEnableModal(false);
    } else {
      setShowDisableModal(false);
    }
    setSelectedActivity(null);
    setSelectActivityId([]);
    setActivityLength(0);
  };

  const handleTreeModalShow = (activity, activityAction) => {
    setSelectedActivity(activity);
    setActivityLength(activity?.disabled_activities.length);
    console.log(activity?.disabled_activities.length, "activity");
    if (activityAction === "enable") {
      setShowEnableTreeModal(true);
    } else {
      setShowDisableTreeModal(true);
    }
  };

  const handleSocialProfilesShow = (user) => {
    setSelectedUserSocialProfiles(user);
    setShowSocialProfilesModal(true);
  };

  const handleTreeModalClose = (activityAction) => {
    if (activityAction === "enable") {
      setShowEnableTreeModal(false);
    } else {
      setShowDisableTreeModal(false);
    }
    setSelectedActivity(null);
    setSelectActivityId([]);
    setActivityLength(0);
  };

  const handleActivity = async (username, action) => {
    try {
      console.log("body", username, action, selectActivityId);
      const { data, error } = await apiCall(
        "post",
        "/disable-enable-activity",
        {
          username: username,
          act_ids: selectActivityId,
          action: action,
        }
      );

      if (data) {
        const queryParams = {
          page: currentPage,
          limit: 20,
        };
        dispatch(fetchAllUsers(queryParams));
        setSelectActivityId([]);
        setActivityLength(0);

        setShowEnableModal(false);
        setShowDisableModal(false);
        if (Array.isArray(data.message)) {
          data.message.forEach((msg) => toast.success(msg));
        } else {
          toast.success(data.message);
        }
      } else if (error) {
        if (Array.isArray(error.message)) {
          error.message.forEach((msg) => toast.error(msg));
        } else {
          toast.error(error.message);
        }
      }
    } catch (error) {
      if (Array.isArray(error.message)) {
        error.message.forEach((msg) => toast.error(msg));
      } else {
        toast.error(error.message);
      }
    }
  };

  const handleActivityTree = async (uid, action) => {
    try {
      console.log("uid:  ", uid);
      console.log("action:  ", action);
      console.log("Selected Act Ids", selectActivityId);
      const { data, error } = await apiCall(
        "post",
        "/block_unblock_tree_activity",
        {
          uid: uid,
          act_ids: selectActivityId,
          action: action,
        }
      );

      if (data) {
        const queryParams = {
          page: currentPage,
          limit: 20,
        };
        dispatch(fetchAllUsers(queryParams));
        setSelectActivityId([]);
        setActivityLength(0);

        setShowEnableTreeModal(false);
        setShowDisableTreeModal(false);

        if (Array.isArray(data.message)) {
          data.message.forEach((msg) => toast.success(msg));
        } else {
          toast.success(data.message);
        }
      } else if (error) {
        if (Array.isArray(error.message)) {
          error.message.forEach((msg) => toast.error(msg));
        } else {
          toast.error(error.message);
        }
      }
    } catch (error) {
      if (Array.isArray(error.message)) {
        error.message.forEach((msg) => toast.error(msg));
      } else {
        toast.error(error.message);
      }
    }
  };

  const handleVersionControl = async () => {
    const version = await handleCreateVersion();
    if (version == true) {
      initializeWebSocket();
    }
  };

  useEffect(() => {
    return () => {
      if (wsRef.current) wsRef.current.close();
      if (reconnectTimeoutRef.current)
        clearTimeout(reconnectTimeoutRef.current);
    };
  }, []);

  const handleCreateVersion = async () => {
    try {
      const body = {
        ticketId: 123456,
      };
      const res = await apiCall("POST", "/auto_create_version", body);
      console.log("response of version control api", res);
      toast.success(res?.data?.message);
      return true;
    } catch (error) {
      toast.error(error.response.data.message);
      return false;
    }
  };

  const reconnectWebSocket = () => {
    if (reconnectTimeoutRef.current) return;
    reconnectTimeoutRef.current = setTimeout(() => {
      initializeWebSocket();
      reconnectTimeoutRef.current = null;
    }, 5000);
  };

  const initializeWebSocket = () => {
    if (wsRef.current) {
      console.log("Closing existing WebSocket connection...");
      wsRef.current.close();
    }
    const newSocket = new WebSocket(SOCKET_SERVER_URL);

    newSocket.onopen = () => {
      console.log("WebSocket connected.");
      newSocket.send(JSON.stringify({ type: "subscribe", ticketId: 123456 }));
      console.log("connected already");
    };

    console.log("now message turn");

    newSocket.onmessage = (event) => {
      console.log("Raw WebSocket message:", event.data);
      try {
        const message = JSON.parse(event.data);
        console.log("Received WebSocket message:", message);
        if (message) {
          console.log("Previous comments received:", message.message);
          dispatch(setProgressMessage(message.message));
          dispatch(setWarningMessage(message.warning));
          dispatch(setCompletedMessage(message.completed));
        } else {
          console.warn("Unexpected WebSocket message format:", message);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    newSocket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    newSocket.onclose = () => {
      console.log("WebSocket disconnected. Reconnecting...");
      reconnectWebSocket();
    };

    wsRef.current = newSocket;
  };

  const handleSponsorChange = async () => {
    try {
      const body = {
        sponsor_username: newSponsor,
      };
      console.log("sponser username: ", newSponsor);
      const res = await apiCall("POST", `/change_sponsor?uid=${uid}`, body);
      console.log("response of sponsor change", res);
      toast.success(res?.data?.message);
      setNewSponsor("");
      setSponsorShow(false);
      setOpenDialogue(true);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleSponsorShow = (uid, sponsorUsername, username) => {
    setUid(uid);
    setSponsorUsername(sponsorUsername);
    setUserName(username);
    setSponsorShow(true);
  };

  const handleDialogueClose = () => {
    setOpenDialogue(false);
    setSponsorShow(false);
  };

  return (
    <React.Fragment>
      <Container>
        {sponsorShow && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Change Sponsor</h2>
              <div className="sponsorDiv">
                <div className="sponsorData">
                  <label>Username:</label>
                  <input name="username" value={userName} readOnly />
                </div>
                <div className="sponsorData">
                  <label>Sponsor Username:</label>
                  <input
                    name="sponsorUsername"
                    value={sponsorUsername}
                    readOnly
                  />
                </div>
                <div className="sponsorData">
                  <div className="d-flex justify-content-between w-100">
                    <label>New Sponsor Username:</label>
                    <label style={{ textAlign: "end" }} htmlFor="newSponsor">
                      {loading && newSponsor ? "Loading..." : existUserName}
                    </label>
                  </div>
                  <input
                    name="newSponsor"
                    placeholder="Sponsor Username"
                    value={newSponsor}
                    onChange={(e) => setNewSponsor(e.target.value)}
                  />
                </div>
                <div className="d-flex gap-2">
                  <Button
                    variant="primary"
                    onClick={handleSponsorChange}
                    // onClick={() => setOpenDialogue(true)}
                  >
                    Submit
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => setSponsorShow(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        <Dialog
          open={openDialogue}
          // onClose={handleDialogueClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Confirmation Sponsor Change
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <p style={{ marginBottom: "10px" }}>
                You have change Sponsor Username for <strong>{userName}</strong>
              </p>
              <p>
                <strong style={{ color: "red" }}>Note:</strong> After performing
                all necessary actions, if you do <u>not</u> want to change the
                sponsor address for any other user, it is{" "}
                <strong>important</strong> to click on{" "}
                <strong>Version Control*</strong>. This step is required to
                finalize and retain the current sponsor address. Otherwise,
                click <strong>All Users</strong>.
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogueClose}>All Users</Button>
            <Button onClick={handleVersionControl} autoFocus>
              Version Control
            </Button>
          </DialogActions>
        </Dialog>

        <div className="pagePath">
          <p className="m-0">Home / All Users</p>
          {/* <Button
            variant="primary"
            onClick={handleVersionControl}
            disabled={!completedMessage}
          >
            Version Control
          </Button> */}
        </div>
        <div className="progressDiv">
          <p>{progressMessage && `${progressMessage}`}</p>
          <p style={{ color: "red" }}>
            {warningMessage && `${warningMessage}`}
          </p>
        </div>
        <Row id="filterRow">
          <span id="filterLogo1" onClick={() => toggleFilter()}>
            <i>
              <BiFilter />
            </i>
            Filter
          </span>
          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Username"
                  name="username"
                  value={search.username}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  placeholder="from date"
                  name="startDateJoining"
                  value={search.startDateJoining}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  placeholder="to date"
                  name="endDateJoining"
                  value={search.endDateJoining}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="limit"
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="status"
                  value={search.status}
                  onChange={handleChange}
                >
                  <option value="">--Status--</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="identify_user"
                  value={search.status}
                  onChange={handleChange}
                >
                  <option value="">Identify User</option>
                  <option value="real">Real</option>
                  <option value="fake">Fake</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={AddFilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <Row id="directTableRow">
          <Col md="12" className="p-0">
            <div style={{ width: "100%" }}>
              <table>
                <tr>
                  <th>S No.</th>
                  <th>Username</th>
                  <th>Wallet Address</th>
                  <th>Login</th>
                  <th>Uid</th>
                  {/* <th>Wallet Address</th> */}
                  <th>Joining Date</th>
                  <th>Activation Date</th>
                  <th>Self Investment</th>
                  {/* <th>Fund Wallet</th> */}
                  <th>Main Wallet</th>
                  {/* <th>Fund Wallet</th> */}
                  <th>Wallet Address</th>
                  <th>Sponsor</th>
                  {/* <th>Sponsor Name</th>
                  <th>Social Profiles</th> */}
                  {/* <th>Change Sponsor</th> */}
                  {/* <th>Disabled Activities</th>
                  <th>Action Activities</th>
                  <th>Tree Action</th> */}
                  <th>Edit Profile</th>
                  <th>Action</th>
                </tr>

                {userData?.data?.map((x, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                      <td>
                        {" "}
                        <div
                          className={`status-dot ${
                            x?.status === 0 ? "inactive" : "active"
                          }`}
                        />
                        {x?.username}
                      </td>
                      <td>{x?.wallet_address}</td>
                      <td>
                        <button
                          className="block-btn"
                          onClick={() => loginUser(x.username)}
                        >
                          Login
                        </button>
                      </td>
                      <td>{x?.uid}</td>
                      {/* <td>{x?.wallet_address}</td> */}
                      <td>
                        {moment(x?.joining_date).format(
                          "MM-DD-YYYY   &   HH:mm"
                        )}
                      </td>
                      <td>
                        {x.Activation_date
                          ? moment(x.Activation_date).format(
                              "MM-DD-YYYY  &  HH:mm"
                            )
                          : " "}
                      </td>
                      <td>{x?.self_investment}</td>
                      {/* <td>{x?.fund_wallet}</td> */}
                      <td>{x?.main_wallet}</td>
                      {/* <td>{x?.fund_wallet}</td> */}
                      <td>{x?.wallet_address}</td>
                      {/*{x?.status === 0 ? (
                        <td style={{ color: "red" }}>Inactive</td>
                      ) : (
                        <td style={{ color: "green" }}>Active</td>
                      )}*/}
                      <td>{x.sponsor_username}</td>
                      {/* <td>{x.sponsor_name}</td>
                      <td>
                        <button
                          className="block-btn"
                          onClick={() => handleSocialProfilesShow(x)}
                        >
                          View Profiles
                        </button>
                      </td> */}
                      {/* <td>
                        <button
                          className="block-btn"
                          onClick={() =>
                            handleSponsorShow(
                              x?.uid,
                              x?.sponsor_username,
                              x?.username
                            )
                          }
                        >
                          Change Sponsor
                        </button>
                      </td> */}
                      {/* <td>
                        {getDisabledActivityNames(
                          x.disabled_activities,
                          activityData
                        )?.map((name, i) => (
                          <div key={i}>
                            <span>
                              {name
                                ?.split("_") // Split the text by underscore
                                ?.map((word, index) =>
                                  index === 0
                                    ? word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                    : word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                )
                                .join(" ")}
                            </span>
                          </div>
                        ))}
                      </td> */}
                      {/* <td className="text-center">
                        <button
                          className="btn btn-success"
                          style={{
                            marginRight: "10px",
                          }}
                          onClick={() => handleButtonClick(x, "enable")}
                        >
                          Enable
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleButtonClick(x, "disable")}
                        >
                          Disable
                        </button>
                      </td> */}
                      <Modal
                        show={showEnableModal}
                        onHide={() => handleDisableModalClose("enable")}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Enable Activity</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p style={{ marginBottom: "2px" }}>
                            Are you sure you want to enable activity for{" "}
                          </p>
                          <p style={{ marginBottom: "5px" }}>
                            Username:{selectedActivity?.username}
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            Disabled Activites are:
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            {activityLength > 0
                              ? getDisabledActivityNames(
                                  selectedActivity?.disabled_activities,
                                  activityData
                                )?.map((name, i) => (
                                  <div key={i}>
                                    <span>
                                      {name
                                        ?.split("_") // Split the text by underscore
                                        ?.map((word, index) =>
                                          index === 0
                                            ? word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                            : word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                        )
                                        .join(" ")}
                                    </span>
                                  </div>
                                ))
                              : "No activity is disabled"}
                          </p>
                          <Form>
                            <Form.Group controlId="formTickMarkGroup">
                              <Form.Label>Select Activities</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {Array.isArray(activityData) &&
                                  activityData
                                    ?.filter(
                                      (x) =>
                                        x?.allowed_roles?.includes("user") &&
                                        x?.status === 1 &&
                                        // Ensure the activity is in the list of disabled activities
                                        selectedActivity?.disabled_activities?.includes(
                                          x?.act_id
                                        )
                                    )
                                    ?.map((x, i) => {
                                      const isSelected =
                                        selectActivityId.includes(x?.act_id);
                                      return (
                                        <div
                                          key={i}
                                          style={{
                                            padding: "10px",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                            backgroundColor: isSelected
                                              ? "#d4edda"
                                              : "#f8d7da",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            minWidth: "150px",
                                          }}
                                          onClick={() => {
                                            if (isSelected) {
                                              // Remove the activity ID from the selected list
                                              setSelectActivityId((prev) =>
                                                prev.filter(
                                                  (id) => id !== x?.act_id
                                                )
                                              );
                                            } else {
                                              // Add the activity ID to the selected list
                                              setSelectActivityId((prev) => [
                                                ...prev,
                                                x?.act_id,
                                              ]);
                                            }
                                          }}
                                        >
                                          <span>
                                            {x?.view
                                              .split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" ")}
                                          </span>
                                          {isSelected && (
                                            <span
                                              style={{
                                                marginLeft: "10px",
                                                color: "green",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              ✔
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })}
                              </div>
                              <div style={{ marginTop: "15px" }}>
                                <p>Selected Activities:</p>
                                <ul>
                                  {selectActivityId.map((id) => {
                                    const activity = activityData.find(
                                      (act) => act.act_id === id
                                    );
                                    return (
                                      <li key={id}>
                                        {activity
                                          ? activity.name.replace(/_/g, " ")
                                          : "Unknown Activity"}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleDisableModalClose("enable")}
                          >
                            Close
                          </Button>
                          <button
                            className="btn btn-success"
                            onClick={() =>
                              handleActivity(
                                selectedActivity?.username,
                                "enable"
                              )
                            }
                          >
                            Enable
                          </button>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        show={showDisableModal}
                        onHide={() => handleDisableModalClose("disable")}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Disabled Activity</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p style={{ marginBottom: "2px" }}>
                            Are you sure you want to disable activity for{" "}
                          </p>
                          <p style={{ marginBottom: "5px" }}>
                            Username:{selectedActivity?.username}
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            Disabled Activites are:
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            {activityLength > 0
                              ? getDisabledActivityNames(
                                  selectedActivity?.disabled_activities,
                                  activityData
                                )?.map((name, i) => (
                                  <div key={i}>
                                    <span>
                                      {name
                                        ?.split("_") // Split the text by underscore
                                        ?.map((word, index) =>
                                          index === 0
                                            ? word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                            : word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                        )
                                        .join(" ")}
                                    </span>
                                  </div>
                                ))
                              : "No activity is disabled"}
                          </p>
                          <Form>
                            <Form.Group controlId="formTickMarkGroup">
                              <Form.Label>Select Activities</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {Array.isArray(activityData) &&
                                  activityData
                                    ?.filter(
                                      (x) =>
                                        x?.allowed_roles?.includes("user") &&
                                        x?.status === 1 &&
                                        // Ensure the activity is NOT in the list of disabled activities
                                        !selectedActivity?.disabled_activities?.includes(
                                          x?.act_id
                                        )
                                    )
                                    ?.map((x, i) => {
                                      const isSelected =
                                        selectActivityId.includes(x?.act_id);
                                      return (
                                        <div
                                          key={i}
                                          style={{
                                            padding: "10px",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                            backgroundColor: isSelected
                                              ? "#d4edda"
                                              : "#f8d7da",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            minWidth: "150px",
                                          }}
                                          onClick={() => {
                                            if (isSelected) {
                                              // Remove the activity ID from the selected list
                                              setSelectActivityId((prev) =>
                                                prev.filter(
                                                  (id) => id !== x?.act_id
                                                )
                                              );
                                            } else {
                                              // Add the activity ID to the selected list
                                              setSelectActivityId((prev) => [
                                                ...prev,
                                                x?.act_id,
                                              ]);
                                            }
                                          }}
                                        >
                                          <span>
                                            {x?.view
                                              .split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" ")}
                                          </span>
                                          {isSelected && (
                                            <span
                                              style={{
                                                marginLeft: "10px",
                                                color: "green",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              ✔
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })}
                              </div>
                              <div style={{ marginTop: "15px" }}>
                                <p>Selected Activities:</p>
                                <ul>
                                  {selectActivityId.map((id) => {
                                    const activity = activityData.find(
                                      (act) => act.act_id === id
                                    );
                                    return (
                                      <li key={id}>
                                        {activity
                                          ? activity.name.replace(/_/g, " ")
                                          : "Unknown Activity"}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleDisableModalClose("disable")}
                          >
                            Close
                          </Button>
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              handleActivity(
                                selectedActivity?.username,
                                "disable"
                              )
                            }
                          >
                            Disable
                          </button>
                        </Modal.Footer>
                      </Modal>

                      <Modal
                        show={showEnableTreeModal}
                        onHide={() => handleTreeModalClose("enable")}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Enable Activity</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p style={{ marginBottom: "2px" }}>
                            Are you sure you want to enable tree activity for{" "}
                          </p>
                          <p style={{ marginBottom: "5px" }}>
                            Username: {selectedActivity?.username}
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            Disabled Activities are:
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            {activityLength > 0
                              ? getDisabledActivityNames(
                                  selectedActivity?.disabled_activities,
                                  activityData
                                )?.map((name, i) => (
                                  <div key={i}>
                                    <span>
                                      {name
                                        ?.split("_")
                                        ?.map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1)
                                        )
                                        .join(" ")}
                                    </span>
                                  </div>
                                ))
                              : "No activity is disabled"}
                          </p>
                          <Form>
                            <Form.Group controlId="formTickMarkGroup">
                              <Form.Label>Select Activities</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {Array.isArray(activityData) &&
                                  activityData
                                    ?.filter(
                                      (x) =>
                                        x?.allowed_roles?.includes("user") &&
                                        x?.status === 1 &&
                                        selectedActivity?.disabled_activities?.includes(
                                          x?.act_id
                                        )
                                    )
                                    ?.map((x, i) => {
                                      const isSelected =
                                        selectActivityId.includes(x?.act_id);
                                      return (
                                        <div
                                          key={i}
                                          style={{
                                            padding: "10px",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                            backgroundColor: isSelected
                                              ? "#d4edda"
                                              : "#f8d7da",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            minWidth: "150px",
                                          }}
                                          onClick={() => {
                                            if (isSelected) {
                                              setSelectActivityId((prev) =>
                                                prev.filter(
                                                  (id) => id !== x?.act_id
                                                )
                                              );
                                            } else {
                                              setSelectActivityId((prev) => [
                                                ...prev,
                                                x?.act_id,
                                              ]);
                                            }
                                          }}
                                        >
                                          <span>
                                            {x?.view
                                              .split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" ")}
                                          </span>
                                          {isSelected && (
                                            <span
                                              style={{
                                                marginLeft: "10px",
                                                color: "green",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              ✔
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })}
                              </div>
                              <div style={{ marginTop: "15px" }}>
                                <p>Selected Activities:</p>
                                <ul>
                                  {selectActivityId.map((id) => {
                                    const activity = activityData.find(
                                      (act) => act.act_id === id
                                    );
                                    return (
                                      <li key={id}>
                                        {activity
                                          ? activity?.view.replace(/_/g, " ")
                                          : "Unknown Activity"}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleTreeModalClose("enable")}
                          >
                            Close
                          </Button>
                          <button
                            className="btn btn-success"
                            onClick={() =>
                              handleActivityTree(
                                selectedActivity?.uid,
                                "enable"
                              )
                            }
                          >
                            Enable
                          </button>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        show={showDisableTreeModal}
                        onHide={() => handleTreeModalClose("disable")}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Disabled Activity</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p style={{ marginBottom: "2px" }}>
                            Are you sure you want to disable tree activity for{" "}
                          </p>
                          <p style={{ marginBottom: "5px" }}>
                            Username: {selectedActivity?.username}
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            Disabled Activities are:
                          </p>
                          <p style={{ marginBottom: "2px" }}>
                            {activityLength > 0
                              ? getDisabledActivityNames(
                                  selectedActivity?.disabled_activities,
                                  activityData
                                )?.map((name, i) => (
                                  <div key={i}>
                                    <span>
                                      {name
                                        ?.split("_")
                                        ?.map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1)
                                        )
                                        .join(" ")}
                                    </span>
                                  </div>
                                ))
                              : "No activity is disabled"}
                          </p>
                          <Form>
                            <Form.Group controlId="formTickMarkGroup">
                              <Form.Label>Select Activities</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {Array.isArray(activityData) &&
                                  activityData
                                    ?.filter(
                                      (x) =>
                                        x?.allowed_roles?.includes("user") &&
                                        x?.status === 1 &&
                                        !selectedActivity?.disabled_activities?.includes(
                                          x?.act_id
                                        )
                                    )
                                    ?.map((x, i) => {
                                      const isSelected =
                                        selectActivityId.includes(x?.act_id);
                                      return (
                                        <div
                                          key={i}
                                          style={{
                                            padding: "10px",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                            backgroundColor: isSelected
                                              ? "#d4edda"
                                              : "#f8d7da",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            minWidth: "150px",
                                          }}
                                          onClick={() => {
                                            if (isSelected) {
                                              setSelectActivityId((prev) =>
                                                prev.filter(
                                                  (id) => id !== x?.act_id
                                                )
                                              );
                                            } else {
                                              setSelectActivityId((prev) => [
                                                ...prev,
                                                x?.act_id,
                                              ]);
                                            }
                                          }}
                                        >
                                          <span>
                                            {x?.view
                                              .split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" ")}
                                          </span>
                                          {isSelected && (
                                            <span
                                              style={{
                                                marginLeft: "10px",
                                                color: "green",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              ✔
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })}
                              </div>
                              <div style={{ marginTop: "15px" }}>
                                <p>Selected Activities:</p>
                                <ul>
                                  {selectActivityId.map((id) => {
                                    const activity = activityData.find(
                                      (act) => act.act_id === id
                                    );
                                    return (
                                      <li key={id}>
                                        {activity
                                          ? activity?.view.replace(/_/g, " ")
                                          : "Unknown Activity"}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleTreeModalClose("disable")}
                          >
                            Close
                          </Button>
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              handleActivityTree(
                                selectedActivity?.uid,
                                "disable"
                              )
                            }
                          >
                            Disable
                          </button>
                        </Modal.Footer>
                      </Modal>

                      {/* <td className="text-center">
                        <button
                          className="btn btn-success"
                          style={{
                            marginRight: "10px",
                          }}
                          onClick={() => handleTreeModalShow(x, "enable")}
                        >
                          Enable
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleTreeModalShow(x, "disable")}
                        >
                          Disable
                        </button>
                      </td> */}

                      <td>
                        <button
                          className="block-btn"
                          onClick={() =>
                            navigate("/dashboard/edit-profile", {
                              state: { user: x },
                            })
                          }
                        >
                          Edit Profile
                        </button>
                      </td>
                      <td>
                        {x?.blockStatus === 0 ? (
                          <button
                            className="btn btn-danger block-btn"
                            onClick={() => handleModalShow(x?.username, 1)}
                          >
                            Block
                          </button>
                        ) : (
                          <button
                            className="btn btn-success block-btn"
                            onClick={() => handleModalShow(x?.username, 0)}
                          >
                            Unblock
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </Col>
        </Row>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {blockStatus === 1 ? "block" : "unblock"}{" "}
            this user?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
            <Button
              variant={blockStatus === 1 ? "danger" : "success"}
              onClick={() => {
                BlockUsers(selectedUser, blockStatus);
                handleModalClose();
              }}
            >
              {blockStatus === 1 ? "Block" : "Unblock"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showTreeModal} onHide={handleTreeModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {treeStatus === 1 ? "enable" : "disable"}{" "}
            this user tree withdrawal?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleTreeModalClose}>
              Cancel
            </Button>
            <Button
              variant={treeStatus === 1 ? "success" : "danger"}
              onClick={() => {
                BlockUserTree(selectedUid, treeStatus);
                handleTreeModalClose();
              }}
            >
              {treeStatus === 1 ? "Enable" : "Disable"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Social Profiles Modal */}
        <Modal
          show={showSocialProfilesModal}
          onHide={() => setShowSocialProfilesModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Social Media Profiles</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedUserSocialProfiles && (
              <div>
                <h5>
                  User: {selectedUserSocialProfiles.name} (
                  {selectedUserSocialProfiles.username})
                </h5>
                <hr />
                {selectedUserSocialProfiles.socialProfiles ? (
                  <div>
                    <h6>Social Media Profiles:</h6>
                    <table
                      style={{
                        width: "100%",
                        marginTop: "15px",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f8f9fa" }}>
                          <th
                            style={{
                              padding: "10px",
                              textAlign: "left",
                              border: "1px solid #ddd",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            Platform
                          </th>
                          <th
                            style={{
                              padding: "10px",
                              textAlign: "left",
                              border: "1px solid #ddd",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            Profile Handle
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(
                          selectedUserSocialProfiles.socialProfiles
                        ).map(([platform, profile]) => (
                          <tr key={platform}>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                                fontSize: "14px",
                                textTransform: "capitalize",
                                fontWeight: "500",
                              }}
                            >
                              {platform}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                                fontSize: "14px",
                                wordBreak: "break-word",
                              }}
                            >
                              {profile || "Not Available"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#666",
                    }}
                  >
                    <p>No social media profiles available for this user.</p>
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowSocialProfilesModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default AllUsers;
